// extracted by mini-css-extract-plugin
export default {"header":"header__PreformHeader__ys4fM","title":"title__PreformHeader__ys4fM","control":"control__PreformHeader__ys4fM"};